import type { FC } from "react";

import { useTranslations } from "@ui/providers/useTranslations";
import classNames from "classnames";

import styles from "./Loading.module.scss";

type DEPRECATED_LoadingProps = {
  dataTestId?: string;
  className?: string;
  whiteDots?: boolean;
};

/**
 * @deprecated Use Loader instead.
 */
export const DEPRECATED_Loading: FC<DEPRECATED_LoadingProps> = ({ dataTestId, className, whiteDots }) => {
  const { __ } = useTranslations();
  const classes = classNames(styles.loading, styles.active, className);
  const dotClasses = classNames(styles.dot, { [styles.whiteDots]: whiteDots });

  return (
    <div role="status" aria-live="polite">
      <span className={styles.visuallyHidden}>{__("hero.loading.text")}</span>
      <ul data-testid={dataTestId} className={classes} aria-hidden="true">
        <li className={dotClasses}></li>
        <li className={dotClasses}></li>
        <li className={dotClasses}></li>
      </ul>
    </div>
  );
};
